import React, { useContext } from "react";
import { Grid, Typography, Button, IconButton, Divider } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { Facebook, Twitter, YouTube, LinkedIn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { RxGlobe } from "react-icons/rx";
import { IoMailOutline } from "react-icons/io5";


const CompanyDetail = ({ onBackToLogin }) => {
    const { t } = useTranslation()
    const { darkMode } = useContext(ThemeContext)

    return (
        <>
            <Grid container alignItems="center" >
                <Grid item xs={12}><Typography variant="h5" fontWeight={700} sx={{ color: darkMode ? "var(--lightText)" : "var(--black)", marginBottom: '20px' }}>{t('companyInformation')}</Typography></Grid>
                <Grid container spacing={1.5} sx={{ marginBottom: '15px' }}>
                    <Grid item xs={12}><Typography textAlign='center' variant="h6" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{process.env.REACT_APP_COMPANY_NAME}</Typography></Grid>
                    <Grid item xs={12}><Typography textAlign='center' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{process.env.REACT_APP_ADDRESS}</Typography></Grid>
                </Grid>
                <Divider />
                <Grid item xs={12} mt={2}><Typography textAlign='center' variant="body1" className="text-gray1">{t('followUs')}</Typography></Grid>
                <Grid item xs={12}>
                    <IconButton component="a" href={process.env.REACT_APP_COMPANY_WEBSITE} target="_blank" rel="noopener noreferrer"><RxGlobe style={{ color:darkMode? "#E6E6FA" :"var(--black)",fontSize:'1.2rem'}} /></IconButton>
                    <IconButton component="a" href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL}`} > <IoMailOutline style={{ color: "#A020F0" ,fontSize:'1.2rem'}} /> </IconButton>
                    <IconButton component="a" href={process.env.REACT_APP_FACEBOOK_URL} target="_blank" rel="noopener noreferrer"><Facebook style={{ color: "#1877F2" ,fontSize:'1.2rem'}} /></IconButton> 
                    <IconButton component="a" href={process.env.REACT_APP_X_URL} target="_blank" rel="noopener noreferrer"> <Twitter style={{ color: "#1DA1F2" ,fontSize:'1.2rem'}} /> </IconButton>
                    <IconButton component="a" href={process.env.REACT_APP_YOUTUBE_URL} target="_blank" rel="noopener noreferrer"> <YouTube style={{ color: "#FF0000",fontSize:'1.2rem' }} /> </IconButton>
                    <IconButton component="a" href={process.env.REACT_APP_LINKEDIN_URL} target="_blank" rel="noopener noreferrer"> <LinkedIn style={{ color: "#0077B5",fontSize:'1.2rem' }} /> </IconButton>
                </Grid>

                <Grid container>
                    <Button fullWidth variant="contained" color="secondary" onClick={onBackToLogin} sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{t('backToLogin')}</Button>
                </Grid>
            </Grid>
        </>
    );
};

export default CompanyDetail;
